import { rankItems } from '@/mocks/collections';
import SectionHead from './Section';

const trendIcon = {
  up: 'ri-arrow-up-line',
  down: 'ri-arrow-down-line',
  flat: 'ri-arrow-right-line',
};
const trendTone = { up: 'text-flame-400', down: 'text-gold-400', flat: 'text-paper-300/60' };
const medal = ['bg-gold-500 text-ink-950', 'bg-paper-200 text-ink-800', 'bg-flame-800 text-paper-50'];

export default function RankSection() {
  return (
    <section id="rank" className="relative overflow-hidden bg-ink-950 py-10 md:py-14 scroll-mt-16">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute right-0 top-0 h-72 w-72 rounded-full bg-flame-900/30 blur-[110px]" />
        <div className="absolute bottom-0 left-1/3 h-72 w-72 rounded-full bg-gold-800/20 blur-[110px]" />
      </div>

      <div className="relative mx-auto max-w-7xl px-4 md:px-6 lg:px-8">
        <SectionHead
          dark
          kicker="本周讨论热榜 · HOT BOARD"
          title="谁在风口浪尖"
          desc="综合讨论量、新增实锤与反转频率排出本周最受关注的人物与事件。热度高未必是坏，也许只是话题多。"
          link="#zone"
        />

        <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
          {rankItems.map((r) => (
            <div
              key={r.id}
              className="group flex items-center gap-4 rounded-xl border border-paper-50/10 bg-paper-50/[0.04] p-4 transition-colors hover:border-flame-500/50 hover:bg-paper-50/[0.08] md:p-5"
            >
              <div
                className={`grid h-11 w-11 shrink-0 place-items-center rounded-lg font-display text-xl font-black ${
                  medal[r.rank - 1] ?? 'bg-paper-50/10 text-paper-200'
                }`}
              >
                {r.rank}
              </div>

              <div className="relative h-16 w-16 shrink-0 overflow-hidden rounded-full ring-2 ring-paper-50/20">
                <img src={r.avatar} alt={r.alias} className="h-full w-full object-cover object-top" />
              </div>

              <div className="min-w-0 flex-1">
                <div className="flex items-center gap-2">
                  <p className="truncate font-bold text-paper-50">{r.alias}</p>
                  <span className={`flex items-center text-sm ${trendTone[r.trend]}`}>
                    <i className={trendIcon[r.trend]} />
                  </span>
                </div>
                <p className="mt-1 truncate text-xs text-paper-200/70">{r.reason}</p>
                <p className="mt-2 flex items-center gap-2 text-xs">
                  <span className="flex items-center gap-1 font-black text-gold-300">
                    <i className="ri-fire-fill text-flame-500" />
                    {r.heat}
                  </span>
                  <span className="text-paper-300/60">·</span>
                  <span className="text-paper-200/70">判定：{r.verdict}</span>
                </p>
              </div>

              <div className="hidden shrink-0 flex-col items-end gap-2 sm:flex">
                <a
                  href="#latest"
                  className="cursor-pointer whitespace-nowrap rounded-full border border-paper-50/25 px-3.5 py-1.5 text-xs font-bold text-paper-100 transition-colors hover:bg-flame-500 hover:text-white"
                >
                  围观
                </a>
                <span className="flex items-center gap-1 text-[11px] text-paper-300/60">
                  <i className="ri-chat-3-line" />
                  热帖 200+
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}